import React, { useState, useRef, useEffect } from 'react';
import { Shield, Award, Users, Network } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const WhyTrustUs = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const points = [
    { icon: Shield, title: t('trust.point1.title'), description: t('trust.point1.description') },
    { icon: Network, title: t('trust.point2.title'), description: t('trust.point2.description') },
    { icon: Award, title: t('trust.point3.title'), description: t('trust.point3.description') },
    { icon: Users, title: t('trust.point4.title'), description: t('trust.point4.description') }
  ];

  return (
    <section ref={sectionRef} className="py-24 bg-neutral-900 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="text-center mb-16">
          <span className="text-red-500 text-sm font-semibold uppercase tracking-wider">{t('trust.badge')}</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4">{t('trust.title')}</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {points.map((point, index) => {
            const Icon = point.icon;
            return (
              <div key={index}
                className={`group relative bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-red-500/50 transition-all duration-500 hover:-translate-y-2 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}>
                <div className="w-14 h-14 rounded-xl bg-red-600/20 flex items-center justify-center mb-4 group-hover:bg-red-600 transition-colors duration-300">
                  <Icon className="text-red-400 group-hover:text-white transition-colors" size={28} />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{point.title}</h3>
                <p className="text-neutral-400 text-sm">{point.description}</p>
              </div>
            );
          })}
        </div>

        <p className="text-center text-neutral-500 text-sm mt-12">{t('trust.disclaimer')}</p>
      </div>
    </section>
  );
};

export default WhyTrustUs;
